import React from 'react';
import {useTranslation} from 'react-i18next';

export function ActivityLogPagination({currentPage, totalPages, totalCount, onPageChange}) {
    const {t} = useTranslation();

    if (totalPages <= 1) return null;

    const pages = [];
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return (
        <div className="activity-log-pagination">
            <span className="pagination-count">
                {t('activity_log.total_entries', {count: totalCount})}
            </span>
            <div className="pagination-buttons">
                <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage <= 1}
                        className="btn -alt -negative">
                    &laquo;
                </button>
                {start > 1 && <span className="pagination-ellipsis">&hellip;</span>}
                {pages.map(p => (
                    <button key={p} onClick={() => onPageChange(p)}
                            className={`btn -alt${p === currentPage ? '' : ' -negative'}`}>
                        {p}
                    </button>
                ))}
                {end < totalPages && <span className="pagination-ellipsis">&hellip;</span>}
                <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= totalPages}
                        className="btn -alt -negative">
                    &raquo;
                </button>
            </div>
        </div>
    );
}
